import {FormControl, TextField, Typography} from "@mui/material"
import React, {useCallback, useContext} from "react"
import {getMerkmal} from "../../misc/widget-functions"
import {getEventValue} from "../../misc/utils"
import {DataContext} from "../../../src/context/DataContextProvider"

export const numberInputPrototype = [
    {
        key: "infotext",
        type: "STRING",
        label: "infotext",
        size: 6,
    },
]

const NumberInput = ({widget, onValueChange}) => {
    const {getDataFromPointer, updateData} = useContext(DataContext)
    const disabled = widget?.disabled || !getMerkmal(widget)?.active
    const {pointer} = getMerkmal(widget)
    const value = getDataFromPointer(pointer)

    const localOnChange = useCallback((event) => {
        const eventValue = getEventValue(event)
        onValueChange(eventValue)
    }, [getEventValue, updateData, pointer])

    return (
        <FormControl fullWidth>
            {widget.text &&
                <Typography className={disabled ? "disabled" : ""} variant="label" mb="4px">
                    {widget.text}
                </Typography>
            }
            <TextField
                type="number"
                label={widget?.label}
                value={value}
                fullWidth
                onChange={localOnChange}
                disabled={disabled}
                placeholder={widget?.placeholder}
            />
            {widget.subtext && (
                <Typography className={disabled ? "disabled" : ""}>
                    {widget.subtext}
                </Typography>
            )}
        </FormControl>
    )
}

export default NumberInput